"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(require('./env'));
__export(require('./universal-module'));
__export(require('../common'));
//# sourceMappingURL=browser.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular2-universal/browser/browser.js
// module id = 292
// module chunks = 0